var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9996 2.3998L1.37461 12.1776L0.599609 11.3776L10.9996 0.799805L21.3996 11.3776L20.6246 12.1776L10.9996 2.3998Z",
    fill: "#077AD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1996 12.7998H11.7996V10.3998H10.1996V12.7998H7.79961V14.3998H10.1996V16.7998H11.7996V14.3998H14.1996V12.7998Z",
    fill: "#077AD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.94961 12.1776L10.9996 3.9998L19.0496 12.1776V19.9998H2.94961V12.1776ZM10.9996 18.3998C13.6506 18.3998 15.7996 16.2508 15.7996 13.5998C15.7996 10.9488 13.6506 8.7998 10.9996 8.7998C8.34864 8.7998 6.19961 10.9488 6.19961 13.5998C6.19961 16.2508 8.34864 18.3998 10.9996 18.3998Z",
    fill: "#077AD3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.5fa707bac912fe6b65f7cd70bfc92741.svg";
export { ForwardRef as ReactComponent };